const StatusBadgeStyle = {
  base: 'inline-block rounded py-0.5 px-2.5 text-[13px] font-medium whitespace-nowrap',
  active: 'bg-green-100 text-green-600',
  cancelled: 'bg-red-100 text-red-600',
  unknown: 'bg-gray-100 text-gray-400',
};

export default StatusBadgeStyle;
